export default __webpack_public_path__ + "static/media/mobile_84.909cb41f.jpg";